import { getStagingEnvironment } from '../../browser-store';
import {
    Application,
    AvroOptional,
    Element,
    Env,
    log as logMessagingWebappJsError,
    MessagingWebappJsError,
} from '@indeed/signals-schema/com/indeed/signals/schema/messaging/MessagingWebappJsError';
import { StagingLevel } from '../../enums/StagingLevel';

export interface SignalsErrorTransportOptions {
    parenttk: string;
}

export class SignalsErrorTransport {
    private readonly parenttk: string;
    private readonly env: Env;

    constructor(options: SignalsErrorTransportOptions) {
        this.parenttk = options.parenttk;
        const stagingLevel: StagingLevel = getStagingEnvironment();
        switch (stagingLevel) {
            case StagingLevel.PRODUCTION:
                this.env = Env.PROD;
                break;
            case StagingLevel.QA:
                this.env = Env.QA;
                break;
            default:
                this.env = Env.UNKNOWN;
        }
    }

    send(logs: any) {
        logs.forEach((log: any) => {
            const errorToLog: MessagingWebappJsError = {
                app: { Application: Application.MESSAGING_WEBAPP },
                columnNumber: AvroOptional.string(log?.data?.col),
                errorMessage: log?.data?.msg || 'missing error message',
                lineNumber: AvroOptional.string(log?.data?.line),
                parenttk: this.parenttk,
                url: AvroOptional.string(log?.data?.url),
                environment: { Env: this.env },
                element: this.parseElement(log),
            };

            logMessagingWebappJsError(errorToLog);
        });
    }

    parseElement(log: any) {
        let element: { Element: Element } | null = null;
        Object.keys(Element).forEach((elementStr) => {
            const formattedElementStr = elementStr.toLowerCase().replace(/_/g, '-');
            if (log?.data?.msg.includes(formattedElementStr)) {
                element = { Element: elementStr as Element };
            }
        });
        return element;
    }
}
